import { Link } from "react-router-dom";
import { COMPANY, NAV } from "@/content";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="wrap">
        <div className="footer-top">
          <div>
            <Link to="/" className="logo">
              <span className="logo-mark">CD</span>
              <span className="logo-text"><b>Cerebral Diagnostics</b><span>Brain Imaging</span></span>
            </Link>
            <p style={{ marginTop: 18, maxWidth: 340 }}>{COMPANY.blurb}</p>
          </div>
          <div className="footer-col">
            <h4>Explore</h4>
            {NAV.map((n) => (<Link key={n.to} to={n.to}>{n.label}</Link>))}
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <p>{COMPANY.address}</p>
            <a href={`tel:${COMPANY.phone}`}>{COMPANY.phone}</a>
            <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.</span>
          <span><Link to="/admin/login">Admin</Link></span>
        </div>
      </div>
    </footer>
  );
}
